import { createFileRoute } from '@tanstack/react-router';
import type { MeetingTemplateKind } from '@wundo/shared/meetingTemplate.ts';
import { MeetingTemplateEditorPage } from '@/components/meeting-templates/MeetingTemplateEditorPage.tsx';
import { useRecordOrganisation } from '@/lib/recordOrganisation.ts';
import { meetingTemplateKindFrom } from '@/lib/meetingTemplateKinds.ts';

/* The kind of the card "New" was clicked on, preselected on the form. */
interface NewOrganisationTemplateSearch {
  kind?: MeetingTemplateKind;
}

export const Route = createFileRoute(
  '/_app/meeting-templates/organisations/$organisationId/new',
)({
  staticData: { orgScope: 'record', orgScopeList: '/meeting-templates' },
  validateSearch: (search: Record<string, unknown>): NewOrganisationTemplateSearch => ({
    kind: meetingTemplateKindFrom(search.kind),
  }),
  component: NewOrganisationTemplateRoute,
});

function NewOrganisationTemplateRoute() {
  const { organisationId } = Route.useParams();
  const { kind } = Route.useSearch();
  useRecordOrganisation(organisationId);

  return (
    <MeetingTemplateEditorPage
      scope='organisation'
      organisationId={organisationId}
      initialKind={kind}
    />
  );
}
